const mobile = 640;
const tablet = 1024;
const laptop = 1300;

export const mobileAndUnder = `(max-width: ${mobile}px)`;
export const tabletAndUnder = `(max-width: ${tablet}px)`;
export const laptopAndUnder = `(max-width: ${laptop}px)`;
